import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=232700e7&scoped=true"
import script from "./Thanks.vue?vue&type=script&lang=ts"
export * from "./Thanks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232700e7",
  null
  
)

export default component.exports